/** PURE_IMPORTS_START .._operator_merge PURE_IMPORTS_END */
import { mergeStatic } from '../operator/merge';
export var merge = mergeStatic;
//# sourceMappingURL=merge.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/merge.js
// module id = 776
// module chunks = 0